<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="documentName"
        @sortChanged="event => emit('sortChanged', event)" @loadMore="emit('loadMore')">
        <template #col-request_date="{ row }">
            {{ renderDate(row.request_date) }}
        </template>
        <template #col-start_date="{ row }">
            {{ renderDate(row.start_date) }}
        </template>
        <template #col-end_date="{ row }">
            {{ renderDate(row.end_date) }}
        </template>
        <template #col-statusName="{ row }">
            <vs-chip :color="row.statusColor">
                {{ $t(row.statusName) | capitalize }}
            </vs-chip>
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { renderDate } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore', 'updateRequest', 'file','upload'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'request_date', label: 'request_date', sortable: false },
    { key: 'start_date', label: 'start_date', sortable: false },
    { key: 'end_date', label: 'end_date', sortable: false },
    { key: 'clientName', label: 'client', sortable: false },
    { key: 'statusName', label: 'status', sortable: false }

])

const actionButtons = ref([
    { text: 'upload', icon: 'UploadIcon', color: 'success', permissions: ['IU Repse'], hideIf: row => ['2','3','4','5'].includes(row.rps_request_status_id), onClick: row => emit('upload',{ id:row.id }) },
    { text: 'files', icon: 'FileIcon', color: 'primary', permissions: ['IU Repse'], hideIf: row => ['1', '5'].includes(row.rps_request_status_id), onClick: row => emit('file', row.id) },
    { text: 'approve', icon: 'CheckSquareIcon', color: 'success', permissions: ['IU Repse'], hideIf: row => row.rps_request_status_id !== '2', onClick: row => emit('updateRequest', { action: 'approve', id: row.id }) },
    { text: 'reject', icon: 'XSquareIcon', color: 'warning', permissions: ['IU Repse'], hideIf: row => row.rps_request_status_id !== '2', onClick: row => emit('updateRequest', { action: 'reject', id: row.id }) },
    { text: 'delete', icon: 'TrashIcon', color: 'danger', permissions: ['IU Repse'],hideIf: row => ['2','3','4','5'].includes(row.rps_request_status_id), onClick: row => emit('updateRequest', { action: 'delete', id: row.id }) }
])


</script>
